import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../utility/local-storage.service';
import { Router } from '@angular/router';
import { PivcApiServices } from '../services/pivc-api.service';
import * as globals from '../utility/global'
import * as languageModel from './language.model';
import { CommonService } from '../utility/common.service';
import { utilityConfig } from '../utility/app-config';
@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss']
})
export class LanguageComponent implements OnInit {
  public langList: any | object = {};
  public contentDetails: any | object = LocalStorageService.get('contentDetails')
    ? LocalStorageService.get('contentDetails')
    : '';
  public langButton: string = utilityConfig.defaultLanguage;
  public questionsList: any | object = {};

  constructor(public restApi: PivcApiServices, public router: Router, public common: CommonService) {}

  /*
  * Initial Hook
  */
  ngOnInit() {
    this.languageList();
    if (
      typeof this.contentDetails !== 'object' &&
      Object.keys(this.contentDetails).length === 0
    ) {
      this.router.navigate(['/']);
    }
  }

  /*
  * Create the Language list defind in Global File.
  * @void
  */
  languageList(): void {
    for (const [key, value] of Object.entries(globals.languageList)) {
      this.langList[key] = value;
    }
  }

  /*
  * Language Selection
  * @void
  */
  languageSelection(langSelected: string): void {
    this.langButton = langSelected;
  }

  /*
  * Recording process starts from here and manipulation of Api response on FLY.
  */
  onSubmit() {
    const apiData = {
      Language: this.langButton,
      ProductCategory: utilityConfig.productCategory,
      PIVC_ID: this.contentDetails.PIVC_ID
    };
    this.restApi
      .getPivcQuestionDetalis(utilityConfig.getPivcQuestionDetalis, apiData)
      .subscribe((data: languageModel.getQuestionDetalisApi) => {
        this.contentDetails.LA_Name = this.common.ucFirst(this.contentDetails.LA_Name);
        const replaceObjectQuestions = {
          '<<CustomerName>>': `<strong>${this.contentDetails.LA_Name}</strong><br>`,
          '<<ProductName>>': `<span>"${this.contentDetails.PlanName}"<br></span>`,
          '<<DOB>>': `<span>${globals.dateformat(this.contentDetails.LA_DOB)}<br></span>`,
          '<<Address>>': `<br><span>${this.contentDetails.LA_Address}</span>`,
          '<<INST>>': `<span>${this.contentDetails.PremiumAmount}</span>`,
          '<<Mode>>': `<span>${this.contentDetails.PremiunPaymentMode}</span>`,
          '<<PPT>>': `<span>${this.contentDetails.PoliyTerm} years</span><br>`,
          '<<NomineName>>': `<span>${this.contentDetails.NOM_Name}</span><br>`,
          '<<NomineDOB>>': `<span>${globals.dateformat(this.contentDetails.NOM_DOB)}</span>`
        };
        const replaceObjectNative = {
          '<<CustomerName>>': this.contentDetails.LA_Name,
          '<<ProductName>>': this.contentDetails.PlanName,
          '<<DOB>>': globals.dateformat(this.contentDetails.LA_DOB),
          '<<Address>>': this.contentDetails.LA_Address,
          '<<INST>>': this.contentDetails.PremiumAmount,
          '<<Mode>>': this.contentDetails.PremiunPaymentMode,
          '<<PPT>>': `${this.contentDetails.PoliyTerm} years`,
          '<<NomineName>>': this.contentDetails.NOM_Name,
          '<<NomineDOB>>': globals.dateformat(this.contentDetails.NOM_DOB)
        };
        const patternCheckQuestions = new RegExp(
          Object.keys(replaceObjectQuestions).join('|'),
          'gi'
        );
        const patternChecknative = new RegExp(
          Object.keys(replaceObjectNative).join('|'),
          'gi'
        );

        data.PivcDetails.forEach((element,i) => {
          this.questionsList.language = element.Language;
          this.questionsList.productCategory = element.ProductCategory;

          this.questionsList[i] = {
            question: element.Question.replace(
              patternCheckQuestions,
              match => replaceObjectQuestions[match]
            ),
            nativeQuestion: element.NativeQuestion.replace(
              patternChecknative,
              match => replaceObjectNative[match]
            ),
            pivcQStatus: element.PIVCQStatus,
            PIVCQID: element.PIVCQID
          };
        });
        LocalStorageService.set('questionsList', this.questionsList);
        this.router.navigate(['/video-recording']);
      });
  }
}
